// @flow

import { useEffect } from 'react'
import { isNotNilOrEmpty } from 'ramda-adjunct'

import { useOpenPanelAnalytics } from '../../providers'

export const useOpenPanelIdentify = (userId: string, options: Object = {}) => {
  const analytics: any = useOpenPanelAnalytics()

  // eslint-disable-next-line complexity
  useEffect(() => {
    if (analytics && isNotNilOrEmpty(userId)) {
      analytics?.identify({
        profileId: userId,
        properties: {
          ...(options?.isGuestCustomer && {
            guest: options?.isGuestCustomer,
          }),
        },
      })
    }
  }, [userId]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useOpenPanelIdentify
